import React from 'react';
export function StickyAlertBar() {
  return <div className="fixed top-0 left-0 w-full h-10 bg-urgency-red text-white z-50 overflow-hidden flex items-center shadow-md" data-id="element-232">
      <div className="whitespace-nowrap animate-marquee font-heading font-bold tracking-wide text-sm md:text-base" data-id="element-233">
        🔥 SOLO POR HOY +7 GUÍAS GRATIS 🔥 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        🔥 SOLO POR HOY +7 GUÍAS GRATIS 🔥 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        🔥 SOLO POR HOY +7 GUÍAS GRATIS 🔥 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        🔥 SOLO POR HOY +7 GUÍAS GRATIS 🔥
      </div>
    </div>;
}